import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { EchartsWithTheme, Empty, useTheme } from '@maxtropy/components';
import { EchartsWithThemeRef } from '@maxtropy/components/es/components/EchartsWithTheme';
import styles from './index.module.scss';
import { ShareDataUnityPowerMapContext, IndexTimeActive } from '../../../..';
import { getDefaultTime } from '@/pages/WgqAllMaps/utils';
import {
  apiV2ElectricMapDataElectricityOverviewPost,
  V2ElectricMapDataElectricityOverviewPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { Spin } from 'antd';
import { getBarChartOption } from '../chart';
import { isEmpty } from 'lodash-es';

const PeakValleyBar = () => {
  const theme = useTheme();
  const { timeResolution: activeKey, dateValue: value, rightExpanded } = useContext(ShareDataUnityPowerMapContext);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [originData, setOriginData] = React.useState<V2ElectricMapDataElectricityOverviewPostResponse>();

  const barChartRef = useRef<EchartsWithThemeRef>(null);
  const containerRefBar = useRef(null);

  useEffect(() => {
    if (!value || !activeKey) return;
    setLoading(true);
    apiV2ElectricMapDataElectricityOverviewPost({
      timeResolution: activeKey === IndexTimeActive.THIS_MONTH ? 'M' : 'Y',
      start: getDefaultTime(activeKey, value).startTime,
      end: getDefaultTime(activeKey, value).endTime,
    })
      .then(res => {
        setOriginData(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [activeKey, value]);

  const chartBarOption = useMemo(
    () => getBarChartOption(originData?.data || [], activeKey === IndexTimeActive.THIS_MONTH ? 'M' : 'Y'),
    [originData?.data, activeKey]
  );

  // ResizeObserver 监听容器大小变化
  useEffect(() => {
    const resizeObserverBar = new ResizeObserver(() => {
      const echartsInstanceBar = barChartRef.current?.getInstance();
      if (echartsInstanceBar) {
        echartsInstanceBar.resize();
      }
    });

    if (containerRefBar.current) {
      resizeObserverBar.observe(containerRefBar.current);
    }

    return () => {
      resizeObserverBar.disconnect();
    };
  }, []);

  // 监听展开状态变化，延迟触发 resize
  useEffect(() => {
    if (rightExpanded) {
      setTimeout(() => {
        const echartsInstanceBar = barChartRef.current?.getInstance();
        if (echartsInstanceBar) {
          echartsInstanceBar.resize();
        }
      }, 100);
    }
  }, [rightExpanded]);

  return (
    <Spin spinning={loading}>
      <div className={styles.container} ref={containerRefBar}>
        <EchartsWithTheme
          empty={{
            isShowEmpty: isEmpty(originData?.data),
            emptyNode: <Empty style={{ marginTop: 20 }} />,
          }}
          ref={barChartRef}
          option={chartBarOption}
          style={{ height: '100%', width: '100%' }}
          theme={theme}
        />
      </div>
    </Spin>
  );
};

export default PeakValleyBar;
